(function() {

    'use strict';

    var RedirectStore = {
        controller: RedirectStoreCtrl,
        controllerAs: '$ctrl',
    };

    RedirectStoreCtrl.$inject = ['timestampSvc','$timeout','$rootScope','ngDialog','CountryService'];

    function RedirectStoreCtrl(timestampSvc,$timeout,$rootScope,ngDialog,CountryService) {

        var _this = this;
        _this.showRedirect = false;
        _this.geoStore = null;
        var dialog;

        _this.$onInit = function(){
            $('html').addClass('new-interstitial');

            _this.hasCookie = inditex.getLocalStorage('reddirect') || false;
            if(!_this.hasCookie){
                joyr.rest.xGetGeolocation().then(function(response){
                    _this.geoCode = response.country_code;
                   
                    if(_this.geoCode !== inditex.iCountryCode){
                        CountryService.getCountriesListName().then(function(countries){
                            for(var i = 0; i < countries.length; ++i){
                                if(countries[i].countryCode  == _this.geoCode){
                                    _this.geoStore = countries[i];
                                    _initRedirect();
                                    break;
                                }
                            }
                        });
                    }
             });
          }
        };

        function capitalizeFirstLetter(string) {
            return string[0].toUpperCase() + string.slice(1).toLowerCase();
        }
 
        function _initRedirect() {
            dialog = ngDialog.open({
                template: 'dialog-redirect-store.tpl',
                className: 'new-modal ma-modal-inter ma-modal-md ngdialog-theme-plain  ',
                showClose: true,
                data:  {redirect: _this.redirect, close:_this.close, from: inditex.iStoreJSON.countryName, to:  capitalizeFirstLetter(_this.geoStore.countryName) },
                bindToController: true
            });
            dialog.closePromise.then(function(){
                inditex.setLocalStorage('reddirect', 1);
            });
        }


        

        _this.redirect = function(){
            window.location.href = '/' + _this.geoStore.countryCode.toLowerCase() + '/';
        };

        _this.close = function(){
            inditex.setLocalStorage('reddirect', 1);
            
            setTimeout(function() {
                $('html').removeClass('new-interstitial');
            }, 800);


            dialog.close();
        };

    }

    angular.module('itxApp.common')
        .component('redirectStore', RedirectStore);
    
})();